import { Button, CheckmarkCircleFilledIcon } from '@calizahq/react-components-v2'
import styled from '@emotion/styled'
import { WorkspaceView } from '@sales-app/context/workspace/workspace.type'
import { getWorkspacePath } from '@sales-app/context/workspace/workspace.util'
import { BookablePersonType } from '@sales-app/types/BookablePersonType'
import { Lead } from '@sales-app/types/Person'
import React, { FC } from 'react'
import { useNavigate } from 'react-router-dom'

type Props = {
  lead: Lead
  toggle: () => void
}

export const CreateConfirmation: FC<Props> = ({ lead, toggle }) => {
  const navigate = useNavigate()
  const openLead = () => {
    toggle()
    const path = getWorkspacePath({
      view: WorkspaceView.SUMMARY,
      type: BookablePersonType.LEAD,
      id: lead.id,
      potentialBookingId: null,
    })

    navigate(path)
  }

  return (
    <ConfirmationStyled className="flex w-full flex-col flex-wrap px-6">
      <h2 className="mb-6 text-header-lg leading-120">New Lead created!</h2>
      <p className=" mb-6 flex items-center rounded-2xl px-6 py-4 text-white bg-accent-dark">
        <CheckmarkCircleFilledIcon className="mr-4 h-4 text-white" />{' '}
        <span className="capitalize leading-none">
          {lead.firstName} {lead.lastName}
        </span>
      </p>
      <div className="line-item">
        <p>Email</p>
        <p className="font-bold" style={{ justifyContent: 'end' }}>
          {lead.email}
        </p>
      </div>
      <div className="line-item">
        <p>Phone</p>
        <p className="font-bold" style={{ alignItems: 'start' }}>
          {lead.phone}
        </p>
      </div>

      <div className="flex flex-col-reverse justify-between md:flex-row">
        <Button
          className="w-full bg-action-secondary md:flex md:w-auto"
          onClick={toggle}
          size="small"
          variant="secondary"
        >
          Close
        </Button>
        <Button
          className="mb-2 w-full bg-text-semantic-success md:mb-0 md:w-auto"
          onClick={openLead}
          size="small"
          type="submit"
        >
          View Lead
        </Button>
      </div>
    </ConfirmationStyled>
  )
}

export const ConfirmationStyled = styled.div`
  .line-item {
    display: flex;
    height: 3.5rem;
    width: 100%;
    justify-content: space-between;
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
    overflow: hidden;
    border-bottom-width: 1px;
    border-color: #e7e6e4;
    margin-bottom: 0.25rem;

    p {
      &:first-of-type {
        line-height: 120%;
        color: #787573;
        display: flex;
        align-items: center;
      }

      &:last-of-type {
        max-width: 50%;
        text-align: right;
        display: flex;
        align-items: center;
      }
    }
  }

  .font-bold {
    font-weight: 700;
  }
`
